import React, { Component } from "react";
import clsx from 'clsx';
import { Route, Link } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import IconButton from '@material-ui/core/IconButton';
import Container from '@material-ui/core/Container';
import MenuIcon from '@material-ui/icons/Menu';
import MailOutline from '@material-ui/icons/MailOutline';
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import SettingsOutlined from '@material-ui/icons/SettingsOutlined';

import Dashboard from "./Dashboard";
import Postcast from "./Postcast";
import Details from "./Postcast/Details";
import Leads from './Leads'
import NewPostcast from "./Postcast/NewPostcast";
import Configuracoes from "./Configuracoes";
import ButtonLogout from "../../componentes/ButtonLogout";
import authHeader from "../Utils/AuthHeader";
import request from "superagent";
import { blogPlayClientType, plugClientType, url_endpoint, url_s3 } from "../../config";
import { Star, SettingsInputAntenna, BarChartOutlined, EditOutlined, PowerSettingsNewOutlined, SpeedOutlined, Mail } from "@material-ui/icons";
import { Avatar, LinearProgress, SvgIcon } from "@material-ui/core";
import TtsAudios from "./ttsAudios";
import Ranking from "./Ranking";
import Help from "./help/help";
import AdCampaings from "./campaigns/AdCampaign";
import NewCampaign from "./campaigns/NewCampaign";
import EditCampaign from "./campaigns/EditCampaign";
import CampaignsDashboard from "./campaigns/CampaignsDashboard";
import palette from "../../theme/palette";

import DashboardIcon from '../../images/icons/dashboard_icon.svg'
import AudiosIcon from '../../images/icons/audio_icon.svg'
import RankingIcon from '../../images/icons/ranking_icon.svg'
import PenEditIcon from '../../images/icons/pen_edit_icon.svg'
import BarsIcon from '../../images/icons/bars_icon.svg'
import LeadsIcon from '../../images/icons/mail_icon.svg'
import InfoIcon from '../../images/icons/info_icon.svg'
import EngineIcon from '../../images/icons/engine_icon.svg'
import LogoutIcon from '../../images/icons/logout_icon.svg'
import SpeedometerIcon from '../../images/icons/speedometer.svg'
import { data } from "jquery";
import { ReactSVG } from "react-svg";

const drawerWidth = 260;

const style = theme => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        backgroundColor: '#f9f9f9',
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        boxShadow: 'none',
        color: 'grey'
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        // flexGrow: 1,
    },
    drawerPaper: {
        borderRight: 'none',
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        maxWidth: '100%',
        backgroundColor: '#f9f9f9',
        'min-height': '93vh'
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
});
//var pagina_titulo = ""
class Painel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            pagina_titulo: "Dashboard",
            urlLogo: "",
            clientName: '',
            clientType: 0,
            charCount: 0,
            monthlyCharacters: 0,
        }
    }


    async componentDidMount() {
        try {
            const res = await request.get(url_endpoint + "cliente/me").set(authHeader())
            if (res.body.admin) {
                this.props.history.push("/admin");
            } else {
                this.props.history.push('/painel')
            }
            this.setState({ clientType: res.body.clientType, clientName: res.body.nome, urlLogo: res.body.img_logo.includes('digitalocean') ? res.body.img_logo : (url_s3 + res.body.img_logo), charCount: res.body.charCount == null ? 0 : parseInt(res.body.charCount), monthlyCharacters: res.body.monthlyCharacters });

        } catch (e) {
            this.props.history.push('/')
            console.log(e)
        }
    }

    handleDrawerOpen = () => {
        this.setState({ open: true })
    }
    handleDrawerClose = () => {
        this.setState({ open: false })
    }

    setTitulo = (titulo) => {
        this.setState({ pagina_titulo: titulo })
    }

    logout() {
        localStorage.setItem("token", null);
        window.location = "/";
    }

    buildSVG(svg, color, colorField = 'fill') {
        return <ReactSVG src={svg} beforeInjection={(svg) => {
            svg.setAttribute(colorField, color)
            svg.setAttribute('width', '20px')
            svg.setAttribute('height', '20px')
        }}></ReactSVG>
    }

    render() {
        const { classes } = this.props;
        const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

        return (
            <div className={classes.root}>
                <div id='customTooltip' style={{ color: 'white', fontWeight: 'bold', background: 'rgba(0, 0, 0, 0.7)', borderRadius: '4px', position: 'absolute' }}></div>
                <CssBaseline />
                <AppBar style={{ backgroundColor: 'transparent' }} position="absolute" className={clsx(classes.appBar, this.state.open && classes.appBarShift)}>
                    <Toolbar className={classes.toolbar}>
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="open drawer"
                            onClick={this.handleDrawerOpen}
                            className={clsx(classes.menuButton, this.state.open && classes.menuButtonHidden)}
                        >

                            <MenuIcon />
                        </IconButton>
                        <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: 'transparent' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <h1 style={{ marginLeft: '5px' }}>{this.state.pagina_titulo}</h1>
                            </div>
                            {/* <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                                {this.state.pagina_titulo}
                            </Typography> */}
                            <div style={{ display: 'flex', alignItems: 'center', columnGap: '10px' }}>
                                <Avatar style={{ backgroundColor: 'transparent' }} variant="square" className={classes.square}>
                                    <img style={{ width: '100%' }} src={this.state.urlLogo}></img>
                                </Avatar>
                                <h3>{this.state.clientName}</h3>
                            </div>
                        </div>
                    </Toolbar>
                    <divider style={{ height: '2px', backgroundColor: 'lightgrey', opacity: '0.3' }}></divider>
                </AppBar>
                <Drawer
                    variant="permanent"
                    classes={{
                        paper: clsx(classes.drawerPaper, !this.state.open && classes.drawerPaperClose),
                    }}
                    open={this.state.open}
                >

                    <div className={classes.toolbarIcon}>
                        {/* <div className={"image_logo_cliente"} style={{ backgroundImage: 'url(https://postcast-front.s3.amazonaws.com/static/imagens/blogPlayLogo.png)', width: '100%', height: '90%' }}></div> */}
                        <img style={{ width: '100%', height: '90%' }} src='https://postcast-front.s3.amazonaws.com/static/imagens/blogPlayLogo.png'></img>
                        <IconButton onClick={this.handleDrawerClose}>
                            <ChevronLeftIcon />
                        </IconButton>
                    </div>
                    <List style={{ height: '92vh', overflowX: 'scroll' }} >
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-around',
                            color: 'grey',
                            fontWeight: 'bold',
                            padding: '0 10px',
                            rowGap: '15px',
                            fontSize: '14px'
                        }}>
                            <ListItem style={{ borderRadius: '5px', backgroundColor: (window.location.pathname == '/painel/Dashboard' || window.location.pathname == '/painel') || (window.location.pathname == '/painel' && this.state.clientType == plugClientType) ? '#f2a404' : 'transparent' }} button component={Link} to={"/painel/Dashboard"}>
                                <ListItemIcon style={{ color: (window.location.pathname == '/painel/Dashboard' || window.location.pathname == '/painel') || (window.location.pathname == '/painel' && this.state.clientType == plugClientType) ? 'white' : 'grey' }}>
                                    {this.buildSVG(DashboardIcon, (window.location.pathname == '/painel/Dashboard' || window.location.pathname == '/painel') || (window.location.pathname == '/painel' && this.state.clientType == plugClientType) ? 'white' : 'grey')}
                                </ListItemIcon>
                                <ListItemText disableTypography={true} style={{ color: (window.location.pathname == '/painel/Dashboard' || window.location.pathname == '/painel') || (window.location.pathname == '/painel' && this.state.clientType == plugClientType) ? 'white' : 'grey', fontSize: '14px' }} primary="Dashboard" />
                            </ListItem>

                            {this.state.clientType == plugClientType &&
                                <ListItem style={{ borderRadius: '5px', backgroundColor: window.location.pathname == '/painel/audiosgerados' ? '#f2a404' : 'transparent' }} button component={Link} to={"/painel/audiosgerados"}>
                                    <ListItemIcon style={{ color: window.location.pathname == '/painel/audiosgerados' ? 'white' : 'grey' }}>
                                        {this.buildSVG(AudiosIcon, window.location.pathname == '/painel/audiosgerados' ? 'white' : 'grey')}
                                    </ListItemIcon>
                                    <ListItemText disableTypography={true} style={{ color: window.location.pathname == '/painel/audiosgerados' ? 'white' : 'grey', fontSize: '14px' }} primary="Áudios" />
                                </ListItem>
                            }

                            {this.state.clientType == blogPlayClientType &&
                                <ListItem style={{ borderRadius: '5px', backgroundColor: window.location.pathname == '/painel/postcasts' ? '#f2a404' : 'transparent' }} button component={Link} to={"/painel/postcasts"}>
                                    <ListItemIcon style={{ color: window.location.pathname == '/painel/postcasts' ? 'white' : 'grey' }}>
                                        {this.buildSVG(AudiosIcon, window.location.pathname == '/painel/postcasts' ? 'white' : 'grey')}
                                    </ListItemIcon>
                                    <ListItemText disableTypography={true} style={{ color: window.location.pathname == '/painel/postcasts' ? 'white' : 'grey', fontSize: '14px' }} primary="Áudios" />
                                </ListItem>
                            }

                            <ListItem style={{ borderRadius: '5px', backgroundColor: window.location.pathname == '/painel/ranking' ? '#f2a404' : 'transparent' }} button component={Link} to={"/painel/ranking"}>
                                <ListItemIcon style={{ color: window.location.pathname == '/painel/ranking' ? 'white' : 'grey' }}>
                                    {this.buildSVG(RankingIcon, window.location.pathname == '/painel/ranking' ? 'white' : 'grey')}
                                </ListItemIcon>
                                <ListItemText disableTypography={true} style={{ color: window.location.pathname == '/painel/ranking' ? 'white' : 'grey', fontSize: '14px' }} primary="Ranking (Beta)" />
                            </ListItem>

                            <ListItem style={{ borderRadius: '5px', backgroundColor: window.location.pathname.includes('campanhas') && !window.location.pathname.includes('dashboard') ? '#f2a404' : 'transparent' }} button component={Link} to={"/painel/campanhas"}>
                                <ListItemIcon style={{ color: window.location.pathname.includes('campanhas') && !window.location.pathname.includes('dashboard') ? 'white' : 'grey' }}>
                                    {this.buildSVG(PenEditIcon, window.location.pathname.includes('campanhas') && !window.location.pathname.includes('dashboard') ? 'white' : 'grey')}
                                </ListItemIcon>
                                <ListItemText disableTypography={true} style={{ color: window.location.pathname.includes('campanhas') && !window.location.pathname.includes('dashboard') ? 'white' : 'grey', fontSize: '14px' }} primary="Gerenciar Campanhas" />
                            </ListItem>

                            <ListItem style={{ borderRadius: '5px', backgroundColor: window.location.pathname.includes('campanhas') && window.location.pathname.includes('dashboard') ? '#f2a404' : 'transparent' }} button component={Link} to={"/painel/campanhas/dashboard"}>
                                <ListItemIcon style={{ color: window.location.pathname.includes('campanhas') && window.location.pathname.includes('dashboard') ? 'white' : 'grey' }}>
                                    {this.buildSVG(BarsIcon, window.location.pathname.includes('campanhas') && window.location.pathname.includes('dashboard') ? 'white' : 'grey')}
                                </ListItemIcon>
                                <ListItemText disableTypography={true} style={{ color: window.location.pathname.includes('campanhas') && window.location.pathname.includes('dashboard') ? 'white' : 'grey', fontSize: '14px' }} primary="Análise de Campanhas" />
                            </ListItem>

                            <ListItem style={{ borderRadius: '5px', backgroundColor: window.location.pathname == '/painel/leads' ? '#f2a404' : 'transparent' }} button component={Link} to={"/painel/leads"}>
                                <ListItemIcon style={{ color: window.location.pathname == '/painel/leads' ? 'white' : 'grey' }}>
                                    {this.buildSVG(LeadsIcon, window.location.pathname == '/painel/leads' ? 'white' : 'grey')}
                                </ListItemIcon>
                                <ListItemText disableTypography={true} style={{ color: window.location.pathname == '/painel/leads' ? 'white' : 'grey', fontSize: '14px' }} primary="Lead Emails" />
                            </ListItem>

                            <divider style={{ height: '2px', backgroundColor: 'lightgrey', opacity: '0.3' }}></divider>

                            <ListItem style={{ borderRadius: '5px', backgroundColor: window.location.pathname == '/painel/ajuda' ? '#f2a404' : 'transparent' }} button component={Link} to={"/painel/ajuda"}>
                                <ListItemIcon style={{ color: window.location.pathname == '/painel/ajuda' ? 'white' : 'grey' }}>
                                    {this.buildSVG(InfoIcon, window.location.pathname == '/painel/ajuda' ? 'white' : 'grey')}
                                </ListItemIcon>
                                <ListItemText disableTypography={true} style={{ color: window.location.pathname == '/painel/ajuda' ? 'white' : 'grey', fontSize: '14px' }} primary="Ajuda" />
                            </ListItem>
                            <ListItem style={{ borderRadius: '5px', backgroundColor: window.location.pathname == '/painel/configuracoes' ? '#f2a404' : 'transparent' }} button component={Link} to={"/painel/configuracoes"}>
                                <ListItemIcon style={{ color: window.location.pathname == '/painel/configuracoes' ? 'white' : 'grey' }}>
                                    {this.buildSVG(EngineIcon, window.location.pathname == '/painel/configuracoes' ? 'white' : 'grey', 'stroke')}
                                </ListItemIcon>
                                <ListItemText disableTypography={true} style={{ color: window.location.pathname == '/painel/configuracoes' ? 'white' : 'grey', fontSize: '14px' }} primary="Configurações" />
                            </ListItem>
                            <ListItem style={{ borderRadius: '5px' }} button onClick={this.logout}>
                                <ListItemIcon>
                                    {this.buildSVG(LogoutIcon, 'grey')}
                                </ListItemIcon>
                                <ListItemText disableTypography={true} style={{ fontSize: '14px' }} primary="Sair" />
                            </ListItem>
                            {this.state.clientType == plugClientType && this.state.open &&
                                <ListItem style={{ margin: '20px 0', display: 'flex', flexDirection: 'column', rowGap: '5px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <ListItemIcon>
                                            {this.buildSVG(SpeedometerIcon, 'grey')}
                                        </ListItemIcon>
                                        <span>Caracteres Disponíveis</span>
                                    </div>
                                    <LinearProgress style={{ width: '100%', height: '10px', borderRadius: '10px' }} variant={'determinate'} value={(this.state.charCount / this.state.monthlyCharacters) * 100} />
                                    <p><span style={{ color: palette.primary.main }}>{this.state.charCount}</span>/{this.state.monthlyCharacters} caracteres</p>
                                </ListItem>
                            }
                            {/*<ListItem button>*/}
                            {/*  <ListItemIcon>*/}
                            {/*    <PersonIcon />*/}
                            {/*  </ListItemIcon>*/}
                            {/*  <ListItemText primary="Minha conta" />*/}
                            {/*</ListItem>*/}

                        </div>
                    </List>

                    {/*<List>{secondaryListItems}</List>*/}
                </Drawer>
                <main className={classes.content}>
                    <div className={classes.appBarSpacer} />
                    <Container style={{ padding: '32px 50px' }} className={classes.container}>
                        <Route exact path="/painel/audiosgerados" render={
                            props => <TtsAudios {...props} setTitulo={this.setTitulo} />
                        } />

                        <Route exact path="/painel/Dashboard" render={
                            props => <Dashboard {...props} setTitulo={this.setTitulo} />
                        } />

                        <Route exact path="/painel/ranking" render={
                            props => <Ranking {...props} setTitulo={this.setTitulo} />
                        } />

                        <Route exact path="/painel/campanhas" render={
                            props => <AdCampaings {...props} setTitulo={this.setTitulo} />
                        } />

                        <Route exact path="/painel/campanhas/nova" render={
                            props => <NewCampaign {...props} setTitulo={this.setTitulo} />
                        } />

                        <Route exact path="/painel/campanhas/editar/:id" render={
                            props => <EditCampaign {...props} setTitulo={this.setTitulo} />
                        } />

                        <Route exact path="/painel/campanhas/dashboard" render={
                            props => <CampaignsDashboard {...props} setTitulo={this.setTitulo} />
                        } />

                        <Route exact path="/painel/leads" render={
                            props => <Leads {...props} setTitulo={this.setTitulo} />
                        } />

                        <Route exact path="/painel/configuracoes" render={
                            props => <Configuracoes {...props} setTitulo={this.setTitulo} />
                        } />

                        <Route exact path="/painel/ajuda" render={
                            props => <Help {...props} setTitulo={this.setTitulo} />
                        } />

                        <Route exact path="/painel" render={
                            props => <Dashboard {...props} setTitulo={this.setTitulo} />
                        } />

                        <Route exact path="/painel/postcasts" render={
                            props => <Postcast {...props} setTitulo={this.setTitulo} />
                        } />

                        <Route exact path="/painel/postcasts/new" render={
                            props => <NewPostcast {...props} setTitulo={this.setTitulo} />
                        } />

                        <Route exact path="/painel/postcasts/detail/:id" render={
                            props => <Details {...props} setTitulo={this.setTitulo} />
                        } />
                    </Container>
                </main>
            </div>
        )
    }
}
export default withStyles(style)(Painel);
